import { render } from "./Leaderboard.vue?vue&type=template&id=70aa56e8&scoped=true"
import script from "./Leaderboard.vue?vue&type=script&lang=js"
export * from "./Leaderboard.vue?vue&type=script&lang=js"

import "./Leaderboard.vue?vue&type=style&index=0&id=70aa56e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70aa56e8"]])

export default __exports__